import { FunctionComponent, h } from 'preact';
import { LayoutHeader } from '@bringg/react-components';
import SharedLocationHeader from '../../features/customer-experience/header/shared-location-header';
import { useStore } from '../../helpers/use-store';
import { observer } from 'mobx-react';
import { get as _get } from 'lodash';

interface Props {
	className?: string;
	footerClassName?: string;
	dataTestId?: string;
}

const SharedLocationLayout: FunctionComponent<Props> = ({ className, footerClassName, children, dataTestId }) => {
	const { customerExperienceStore } = useStore();
	const { ui_data } = customerExperienceStore.customerExperience || {};

	return (
		<div className={className} data-testid={dataTestId}>
			<LayoutHeader className="customer-experience-header-layout">
				<SharedLocationHeader merchantLogo={_get(ui_data, 'merchant_logo')} />
			</LayoutHeader>
			{children}
		</div>
	);
};

export default observer(SharedLocationLayout);
